import React from 'react';
import './CTA_parselings.css';
import ctaPng from '../../../assets/images/parselings/cta.png';
import ctaWebp from '../../../assets/images/parselings/cta.webp';

const CTA = () => {
  return (
    <div className="cta-container">
      <div className="cta-content">
        <div className="cta-left">
          <div className="word-definition">
            <h2>/paːz : lin/</h2>
            <p className="part-speech">noun: Parseling; plural noun: Parselings</p>
            
            <div className="definition-entries">
              <div className="definition-entry">
                <span className="entry-number">1.</span>
                <p>An Infected Human branded by the labels the world assigns them. When alone, they are no different than an average person. Only when their words bleed in with their own kind will their true potential emerge.</p>
              </div>
              
              <div className="definition-entry">
                <span className="entry-number">2.</span>
                <p>A deck building Tabletop RPG focused on the themes of connection and cooperation. Using a standard set of playing cards, you will forge a deck that represents your character. With this, your friends and a GM, you will tell a story that only you can create.</p>
              </div>
            </div>

            <div className="tools-required">
              <h3>Tools Required:</h3>
              <ul>
                <li>A deck of playing cards per player</li>
                <li>A set of dice, d6, d10 and d20</li>
                <li>Your imagination</li>
              </ul>
            </div>
          </div>
        </div>
        
        <div className="cta-right">
          <picture>
            <source srcSet={ctaWebp} type="image/webp" />
            <img src={ctaPng} alt="Parselings Call to Action" />
          </picture>
        </div>
      </div>
    </div>
  );
};

export default CTA;